module.exports = __webpack_public_path__ + "8450fdb64e742df71dca2895a53d4548.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-2.png
// module id = 2045
// module chunks = 0